export default {

  async getNotifications ({
    commit,
    dispatch,
    state
  }, { page, groupKey }) {
    try {
      if (this.$auth.loggedIn) {
        // console.log('getNotifications', page)
        const storeCode = this.app.i18n.locale
        let pageParam
        if (page) {
          pageParam = page
        } else {
          pageParam = state.page
        }

        await this.$axios.get(`/private/notifications/pages/get?page=${pageParam}&storeCode=${storeCode}&groupKey=${groupKey}`)
          .then((response) => {
            const { data } = response
            if (data.notifications) {
              data.notifications.forEach(async (notification) => {
                commit('pushNotification', notification)

                if (notification?.message?.callToActionResponseTypeCode === 'email_verified_profile_as_merchant_completed') {
                  await dispatch('customer/getCustomer', {}, { root: true })
                } else if (notification?.message?.callToActionResponseTypeCode === 'email_verified_profile_completed') {
                  await dispatch('customer/getCustomer', {}, { root: true })
                }
              })

              commit('setOpenReadMes', data.unRead)
              commit('setOpenCtas', data.openCtas)
              commit('setTotal', data.total)
            }
            return data
          })
      }
    } catch (e) {
      console.error('could not get notifications', e)
    }
  },

  async pushNotification ({
    commit,
    dispatch
  }, notification) {
    commit('pushNotification', notification)

    if (notification?.message?.callToActionResponseTypeCode === 'email_verified_profile_as_merchant_completed' ||
      notification?.message?.callToActionResponseTypeCode === 'email_verified_profile_completed' ||
      notification?.message?.callToActionResponseTypeCode === 'merchant_reviewed_and_ready_for_auction'
    ) {
      await dispatch('customer/getCustomer', {}, { root: true })
    }
  },

  markAsReadByGroupKey ({ commit }, groupKey) {
    commit('markAsReadByGroupKey', groupKey)
  },

  setActiveGroupKey ({ commit }, groupKey) {
    commit('setActiveGroupKey', groupKey)
  }

}
